<template>
<panel>
  <p slot="header">
    {{ item.email }} <span class="gray">(adres e-mail)</span>
  </p>
  <p slot="actions">
    <ui-button type="flat" color="primary" icon="navigate_before" @click.prevent="$router.push({name: 'admin.emails.show', params: {id: item.id}})">Anuluj</ui-button>
  </p>
  <emails-form :item="item" v-if="item.id"></emails-form>
</panel>

</template>
<script>
import Emails from './../../services/Emails'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      item: Emails.getBaseItem()
    }
  },
  mounted () {
    const id = this.$route.params.id
    this.getItem(id)
  },
  methods: {
    cancel () {
      this.$router.push({name: 'admin.emails.show', params: {id: this.item.id}})
    },
    getItem (id) {
      this.setLoading(true)
      Emails.get(id).then((res) => {
        this.item = res.data.item
        this.setLoading(false)
      })
    }
  }
}

</script>


// WEBPACK FOOTER //
// Edit.vue?5e675cb8